import React, { RefObject } from 'react';
import { getAdByWidthHeight } from '../../components/common/ads';
import styled from 'styled-components';

type AdDisplayWidgetProps = {
    width: number;
    height: number; 
    registeredSlotId: string;
    adLoaded: boolean;
    adLoadFailed: boolean;
    adError: boolean;
    displayDefaultAd?: boolean; 
    adEnabled: boolean;
    showDefaultGDPRUser: boolean;
    adUnitRef: RefObject<HTMLDivElement> | null;
}
export const AdDisplayWidget = ({ 
    width, 
    height, 
    registeredSlotId, 
    adLoaded, 
    adUnitRef, 
    displayDefaultAd = true, 
    showDefaultGDPRUser = false,
    adEnabled = true, 
    adLoadFailed = false, 
    adError = false }: AdDisplayWidgetProps) => {
    const defaultAd = getAdByWidthHeight(width, height);
    
    let showDefaultAd = false;
    if (adEnabled && !showDefaultGDPRUser) {
        if (adLoaded) {
            showDefaultAd = false;
        } else if (adError === true || adLoadFailed === true) {
            showDefaultAd = true;
        }
    } else if (showDefaultGDPRUser) {
        showDefaultAd = true;
    }

    return (
        <div style={{ width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
            <div>
                <div id={registeredSlotId} ref={adUnitRef}>
                    {
                        showDefaultAd
                            ? <a href={defaultAd.href} aria-label='Download WeatherBug App'>
                                <img
                                    alt=''
                                    width={width}
                                    height={height}
                                    src={defaultAd.src}
                                />
                            </a>
                            : null
                    }
                </div>
            </div>
        </div>
    );
};
